import { MappedClass, MappedPropertyOptional } from '@h5s/util-object';
import { ZPrinterFiscalPrinterStatus } from './z-printer-fiscal-printer-status';
import { ZPrinterFiscalProtocolType } from './z-printer-fiscal-protocol-type';
import { ZPrinterReceiptStatus } from './z-printer-receipt-status';

@MappedClass()
export class ZPrinterFiscalMessage {
  @MappedPropertyOptional()
  adds?: number | null;

  @MappedPropertyOptional()
  checksum?: string | null;

  @MappedPropertyOptional()
  checksum_calculated?: string | null;

  @MappedPropertyOptional()
  checksum_verified?: boolean | null;

  @MappedPropertyOptional()
  control_code?: string | null;

  @MappedPropertyOptional()
  data?: string | null;

  @MappedPropertyOptional()
  error_code?: string | null;

  @MappedPropertyOptional()
  error_type?: string | null;

  @MappedPropertyOptional()
  fiscal_protocol_type?: ZPrinterFiscalProtocolType | null;

  @MappedPropertyOptional()
  follow?: boolean | null;

  @MappedPropertyOptional()
  header1?: string | null;

  @MappedPropertyOptional()
  header2?: string | null;

  @MappedPropertyOptional()
  is_dump?: boolean | null;

  @MappedPropertyOptional()
  is_error?: boolean | null;

  @MappedPropertyOptional()
  length?: number | null;

  @MappedPropertyOptional()
  op?: string | null;

  @MappedPropertyOptional()
  packet_id?: string | null;

  @MappedPropertyOptional()
  packet_id_modulus?: string | null;

  @MappedPropertyOptional()
  protocol?: string | null;

  @MappedPropertyOptional()
  raw?: string | null;

  @MappedPropertyOptional()
  receipt_status?: ZPrinterReceiptStatus | null;

  @MappedPropertyOptional()
  status?: ZPrinterFiscalPrinterStatus | null;
}
